module.exports = __webpack_public_path__ + "img/jljj-tab-pc.3fbadd10.svg";